// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListFilterAccordionSectionStyles } from "@bg/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            border: 0;
            padding: 0;
            border: 0;
        `,
    },
    headerProps: {
        css: css`
            background: ${getColor("white")};
            margin-bottom: ${fontConfig.spacing.xSmallHeading};

            button {
                background: none;
                display: flex;
                justify-content: space-between;
                &,
                &:focus {
                    padding: 0 10px 0 0 !important;
                    border: 0 !important;
                }

                > span:nth-child(1) {
                    font-size: ${fontConfig.fontSize.regular}px;
                    font-weight: ${fontConfig.weight.bold};
                    letter-spacing: 0.23px;
                    line-height: 20px;
                    text-transform: uppercase;
                }

                > span:nth-child(2) {
                    border: 0;
                    background: ${getColor("white")};
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &,
                    > * {
                        position: static;
                    }

                    svg {
                        width: 18px;
                        height: 18px;
                        color: ${getColor("text.main")};
                    }
                }
            }
        `,
        "aria-level": 2,
    },
};

productListFilterAccordionSectionStyles.seeAllLink = {
    color: "text.main",
    css: css`
        margin-top: 15px;
        &,
        span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};

productListFilterAccordionSectionStyles.seeLessLink = {
    color: "text.main",
    css: css`
        margin-top: 15px;
        &,
        span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
            font-weight: ${fontConfig.weight.regular};
        }
    `,
};
